import Vue from 'vue';
import io from 'socket.io-client';
import config from '@/config';
import { CLIENT_CONNECT, SOCKET_UPDATE_SLIDE } from '@/config/constants';

// @ts-ignore
// @ts-ignore
// @ts-ignore
export default Vue.extend({
  data() {
    return {
      io: null
    };
  },
  watch: {
    '$store.state.auth.isLoggedIn': {
      handler(a, o) {
        if (a === true) {
          // @ts-ignore
          this.connect();
          this.register();
        } else {
          // @ts-ignore
          if (this.io !== null) {
            // @ts-ignore
            this.io.destroy();
          }
        }
      }
    }
  },
  mounted(): void {
    // @ts-ignore
    if (this.$store.state.auth.isLoggedIn) {
      // @ts-ignore
      this.connect();
      // @ts-ignore
      this.register();
    }
  },
  destroyed(): void {
    // @ts-ignore
    this.io = null;
  },
  methods: {
    connect() {
      // @ts-ignore
      // @ts-ignore
      this.io = io(config.SOCKET_BASE_URL, {
        secure: true,
        transports: ['websocket'],
        query: {
          token: this.$store.state.auth.token,
          email: this.$store.state.user.me.email
        }
      });
    },
    register() {
      // @ts-ignore
      if (!this.io) {
        return;
      }
      // @ts-ignore
      this.io.on('update-client', this.clientEvent);
      // @ts-ignore
      this.io.on('update', this.updateSlide);
    },
    clientEvent(user: { email: string; data: any }) {
      if (this.$store.state.user.me.email === user.email) {
        this.$store.commit(CLIENT_CONNECT, user.data.client);
      }
    },
    async updateSlide(slide: object) {
      await this.$store.dispatch(SOCKET_UPDATE_SLIDE, slide);
    }
  }
});
